import { z } from 'zod'
import i18next from '../i18next'

export const PermissionSchema = z.enum([
  'VOLUME_WRITE',
  'VOLUME_DELETE',
  'SPECIMEN_DELETE',
  'REFERENCE_WRITE',
  'USER_READ',
  'USER_WRITE',
  'TEMPLATE_MANAGE',
])

export const EditableUserSchema = z.object({
  id: z.string(),
  email: z.email(i18next.t('schema.email')),
  userName: z.string(),
  firstName: z.string().min(1, i18next.t('schema.first_name_min_length')),
  lastName: z.string().min(1, i18next.t('schema.last_name_min_length')),
  role: z.enum(['user', 'admin', 'digitalization']),
  active: z.boolean(),
  owners: z.string().array().nullable(),
})

export const MeSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.email(i18next.t('schema.email')),
  authorities: z.string().array(),
  owners: z.string().array().nullable(),
  enabled: z.boolean(),
  username: z.string(),
  role: z.enum(['user', 'admin', 'digitalization']),
  accountNonExpired: z.boolean(),
  accountNonLocked: z.boolean(),
  credentialsNonExpired: z.boolean(),
})

export const BasicLoginSchema = z.object({
  username: z.string().trim().min(1, i18next.t('schema.username_required')),
  password: z.string().min(1, i18next.t('schema.password_required')),
})

export type TUser = z.infer<typeof EditableUserSchema>
export type TMe = z.infer<typeof MeSchema>
export type TBasicLogin = z.infer<typeof BasicLoginSchema>
export type TPermission = z.infer<typeof PermissionSchema>

export const hasPermission = (
  me: TMe | null | undefined,
  permission: TPermission
) => me?.authorities?.includes(permission) ?? false
